import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { IsLoginProvider } from './login/IsLoginContext'

import Main from './pages/Main';
import Login from './pages/Login';
import Unauthorized from './pages/Unauthorized';
import Callback from './pages/Callback';

function App() {
  return (
    <BrowserRouter>
      <IsLoginProvider>
        <Routes>
          <Route path={'/'} element={<Main />} />
          <Route path={'/login'} element={<Login />} />
          <Route path={'/callback'} element={<Callback />} />
          <Route path={'/unauthorized'} element={<Unauthorized />} />
        </Routes>
      </IsLoginProvider>
    </BrowserRouter>
  );
}

export default App;